namespace $ {
	export class $mol_form_group extends $mol_view {
	}
	
}

